/**
 * Betriebe Auswahl aktualisieren
 * @param html
 * @param scope
 */
window.updateBetriebe = function(html, scope) {
  const fullsearchBetriebeParents = $('#fullsearch-betriebe').parents();
  const filterParent = fullsearchBetriebeParents[2];
  $(filterParent).html(html);
  if (scope === 'feldkontrollen') {
    fullTextSearch('#fullsearch-betriebe', 'fullTextBetrieb', ListFeldkontrollen);
  } else if (scope === 'oekologischeMassnahmen') {
    fullTextSearch('#fullsearch-betriebe', 'fullTextBetrieb', ListOekologischeMassnahmen);
  } else if (scope === 'anlieferungslieferscheine') {
    fullTextSearch('#fullsearch-betriebe', 'fullTextBetrieb', ListAnlieferungslieferscheine);
  }
};

/**
 * Kultur Auswahl aktualisieren
 * @param html
 * @param scope
 */
window.updateKulturen = function(html, scope) {
  const fullsearchKulturenParents = $('#fullsearch-kulturen').parents();
  const filterParent = fullsearchKulturenParents[2];
  $(filterParent).html(html);

  if (scope === 'oekologischeMassnahmen') {
    fullTextSearch('#fullsearch-kulturen', 'fullTextKultur', ListOekologischeMassnahmen);
  }
};

window.triggerLevelExpander = function() {
  const firstTrigger = $('#show-first-level');
  const secondTrigger = $('#show-second-level');

  // je nach Gruppierung müssen sich andere Level öffnen/schließen
  var openFirstTrigger = '.expand-item-level-1, .expand-item-level-2';
  var closeSecondTrigger = '.expand-item-level-3';
  if ($('#fullsearch-groupBy').val() === 'betrieb') {
    openFirstTrigger = '.expand-item-level-1';
    closeSecondTrigger = '.expand-item-level-2, .expand-item-level-3';
  }

  firstTrigger.on('click', function() {
    if (firstTrigger.hasClass('active')) {
      $('.expand-item-level-1, .expand-item-level-2, .expand-item-level-3').each(function() {
        $(this).addClass('level-hide');
      });
      firstTrigger.removeClass('active');
    } else {
      $(openFirstTrigger).each(function() {
        $(this).removeClass('level-hide');

      });
      firstTrigger.addClass('active');
    }
    secondTrigger.removeClass('active');

    checkExpanderIcon();
  });

  secondTrigger.on('click', function() {
    if (secondTrigger.hasClass('active')) {
      $(closeSecondTrigger).each(function() {
        $(this).addClass('level-hide');
      });
      secondTrigger.removeClass('active');
    } else {
      $('.expand-item-level-1, .expand-item-level-2, .expand-item-level-3').each(function() {
        $(this).removeClass('level-hide');
      });
      secondTrigger.addClass('active');
      if (!firstTrigger.hasClass('active')) {
        firstTrigger.addClass('active');
      }
    }

    checkExpanderIcon();
  });
};

/**
 *
 * @param tableElement
 * @param selectAll
 * @param selectLevel
 * @param selectRow
 * @param editDataButton
 */
window.updateList = function(tableElement, selectAll, selectLevel, selectRow, editDataButton) {
  checkboxLevel(tableElement, selectAll, selectLevel, selectRow, editDataButton);
  expanderLevel();
  updateCheckAllState(tableElement, selectAll, selectLevel);
};

/**
 *
 * @param selectLevel
 * @param selectRow
 * @param selectAll
 */
window.updateDisabledRows = function(selectLevel, selectRow, selectAll) {
  $(selectRow).each(function() {
    // selektierte Row
    const selectedRow = $(this).closest('[data-level]');
    // selektiertes Level
    const rowLevel = selectedRow.data('level');
    if (rowLevel > 1) {
      for (let i = (rowLevel - 1); i >= 1; i--) {
        let parentRow = selectedRow.prevAll('[data-level="' + i + '"]').first();
        let parentRowCheckbox = parentRow.find('input[type="checkbox"].' + selectLevel);
        if (parentRow.length && parentRowCheckbox.length) {
          let parentRowDisabled = false;
          let parentRowChildren = parentRow.nextUntil('[data-level="' + i + '"]', '[data-level="' + (i + 1) + '"]');
          let parentRowChildrenNotDisabledExists = (parentRowChildren.find('input[type="checkbox"].' + selectLevel + ':not(:disabled)').length);

          if (parentRowChildrenNotDisabledExists === 0) {
            parentRowDisabled = true;
          } else {
            parentRowDisabled = false;
          }

          switch (parentRowDisabled) {
            case true:
              $(parentRowCheckbox).removeClass(selectLevel).prop('disabled', true).prop('checked', false);
              break;
            default:
              $(parentRowCheckbox).prop('disabled', false);

          }
        }
      }
    }
  });

  const allDisabled = ($('input[type="checkbox"].select-level2:not(:disabled)').length);
  if (allDisabled === 0) {
    $(selectAll).prop('disabled', true).prop('checked', false);
  } else {
    $(selectAll).prop('disabled', false);
  }
};